<template>
    <Layout
        :header="{ text: titleText, backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫資料', '確認資料', '視訊預約',]" :index="3"></Process>
        </div>
        <div class="pb-8">
            <h2 class="font-bold text-2xl">
                預約視訊驗證
            </h2>
            <p class="pt-2">本公司將發送視訊連結至以下留存之行動電話，若資訊不正確，請與您的服務人員聯繫或致電本公司0809-000-550辦理行動電話變更。</p>
        </div>
        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">
                發送簡訊之行動電話
            </h3>
            <ul>
                <li class="pb-4">
                    <h5 class="font-bold text-md pb-2">
                        要保人：{{ applicantName }}
                    </h5>
                    <input class="w-full" type="text" inputmode="tel" :disabled="disabledApplicantPhone"
                        v-model="applicantPhone" placeholder="請輸入行動電話">
                    <p class="text-[#C10013] pt-2">將以此電話完成OTP驗證及發送視訊連結簡訊</p>
                </li>
                <li v-if="assuredRequired">
                    <h5 class="font-bold text-md pb-2">
                        被保險人：{{ assuredName }}
                    </h5>
                    <input class="w-full" type="text" inputmode="tel" :disabled="disabledAssuredPhone"
                        v-model="assuredPhone" placeholder="請輸入行動電話">
                    <p v-if="!disabledAssuredPhone" class="text-[#C10013] pt-2">同時變更您本次預約申請的保單之被保險人行動電話</p>
                </li>
            </ul>
        </div>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="!isPass" @click="submit">下一步</button>
        </template>
        <Loading :is-loading="isLoading" />
        <InfoBox v-if="errorBoxVisble" :closeHandel="closeBox" title="系統提示">
            <div v-html="errorMessage" />
        </InfoBox>
    </Layout>
</template>
<script setup>

import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import Loading from '@/components/Loading.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'

import { ref, computed, defineProps, } from 'vue';
import { useRouter } from 'vue-router';
import { getContactInfo } from '@/apis/system';
import { submitContact } from '@/apis/applicantChange'
import { useStore } from 'vuex';
import aplCatlCode from '@/json/aplCatlCode';
import routeName from '@/router/constant';

const router = useRouter();
const store = useStore();
const policyData = computed(() => store.state.policy.policy);
const isLoading = ref(false);

// 要保人電話
const applicantPhone = ref('');
const applicantName = ref(policyData.value.insName);
const disabledApplicantPhone = ref(false);
// 被保險人有變更
const assuredRequired = ref(true);
// 被保險人電話
const assuredPhone = ref('');
const assuredName = ref(policyData.value.name);
const disabledAssuredPhone = ref(false);
const titleText = ref('');
const phoneData = ref({});
const errorBoxVisble = ref(false);
const errorMessage = ref('');
const errorType = ref('');


const aplCatl = computed(() => store.state.services.aplCatl);
const isPass = computed(() => {
    if (assuredRequired.value) {
        return applicantPhone.value && assuredPhone.value ? true : false
    } else {
        return applicantPhone.value ? true : false
    }
})

if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
    titleText.value = '受益人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_CHANGE) {
    titleText.value = '要保人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
    titleText.value = '要保人或被保險人姓名變更'
}

const initData = async () => {
    isLoading.value = true;
    try {
        const resData = await getContactInfo()
        phoneData.value = resData.data;

        applicantPhone.value = maskData(resData.data?.mobile);
        assuredPhone.value = maskData(resData.data?.insuredMobile);
        disabledApplicantPhone.value = resData.data?.mobile ? true : false;
        disabledAssuredPhone.value = resData.data?.insuredMobile ? true : false;
        assuredRequired.value = resData.data?.needDisplay;

        if (!/^09\d{8}$/.test(resData.data?.mobile)) {
            errorMessage.value = '您的行動電話為國外電話，考量作業時效，本次無法使用雲端e櫃檯服務功能，請通知您的服務人員協助辦理，或洽詢免付費服務電 0809-026-688，造成您的不便，敬祈見諒！';
            errorBoxVisble.value = true;
            errorType.value = 'STOP_PROCESS';
            return;
        }

        if (resData.data?.needDisplay && resData.data?.insuredMobile && !/^09\d{8}$/.test(resData.data?.insuredMobile)) {
            errorMessage.value = `被保險人 ${assuredName.value} 的行動電話為國外電話，考量作業時效，本次無法使用雲端e櫃檯服務功能，請通知您的服務人員協助辦理，或洽詢免付費服務電 0809-026-688，造成您的不便，敬祈見諒！`;
            errorBoxVisble.value = true;
            errorType.value = 'STOP_PROCESS';
            return;
        }

        // 被保險人與要保人不同人，但主檔留存電話相同，若視訊對象僅要保人，不可出現「要保人與被保險人電話不可相同！」之訊息
        if (resData.data?.needDisplay && resData.data?.id !== resData.data?.insuredId && resData.data?.mobile === resData.data?.insuredMobile) {
            errorMessage.value = `要保人與被保險人電話不可相同！`;
            errorBoxVisble.value = true;
            errorType.value = 'STOP_PROCESS';
            return;
        }

    } catch (e) { console.log(e) }
    finally {
        isLoading.value = false;
    }
}
initData();

const maskData = (val) => {
    if (!val || val.length < 10) return '';
    const start = val.substring(0, 3);
    const end = val.substring(7);
    return `${start}*****${end}`;
}

const submit = () => {
    errorMessage.value = '';
    let mobile = disabledApplicantPhone.value ? phoneData.value.mobile : applicantPhone.value;
    let insuredMobile = disabledAssuredPhone.value ? phoneData.value.insuredMobile : assuredPhone.value
    if (!/^09\d{8}$/.test(mobile)) {
        errorMessage.value = '您輸入的行動電話為外國門號，考量作業時效，請改輸入台灣門號，謝謝！'
        errorBoxVisble.value = true;
        return;
    }
    if (assuredRequired.value && !/^09\d{8}$/.test(insuredMobile)) {
        errorMessage.value = `您輸入的被保險人 ${assuredName.value} 行動電話為外國門號，考量作業時效，請改輸入台灣門號，謝謝！`
        errorBoxVisble.value = true;
        return;
    }
    goNextPage({ mobileCountry: "", email: "", mobile, insuredMobile, })
}

const goNextPage = async (data) => {
    isLoading.value = true;
    try {
        const result = await submitContact(data)
        router.push({ name: routeName.CLOUD_E_COUNTER_PERIOD });
    } catch (e) {
        errorMessage.value = e.data?.errorMessage;
        errorBoxVisble.value = true;
    } finally {
        isLoading.value = false;
    }
}

const closeBox = () => {
    if (errorType.value === 'STOP_PROCESS') {
        router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
    }
    errorBoxVisble.value = false;
}

</script>
<style lang="scss" scoped></style>
